/** @jsx h */
// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropType from 'prop-types';

import {
  assetResolver,
} from '../../utils';

import {
  navigationItemPropType,
} from '../../propTypes';

import {
  Item,
  NavigationItemContainer,
  ArrowLeft,
  NavigationItemLink,
  IconImage,
  ArrowRight,
} from './styles';

const PrimaryNavigationItemMobile = ({
  item, primarySiteColor, onMenuClick, onMenuReturn, alternate,

}) => (
  <NavigationItemContainer
    alternate={alternate}
    borderWidth={item.borderWidth}
    borderColor={item.borderColor}
  >
    <NavigationItemLink
      item={item}
      alternate={alternate}
      primaryColor={primarySiteColor}
      onClick={!item.link ? (onMenuClick || onMenuReturn) : undefined}
    >
      <Item isReturn={item.return}>
        {item.return ? (<ArrowLeft src={assetResolver('arrow-left.svg')} alt="Back" />) : (null)}
        {(item.icon && !item.return) ? (<IconImage src={assetResolver(`${item.icon}.svg`)} alt={item.icon} />) : (null)}
        {item.image ? (<img src={item.image} alt={item.imageAlt} />) : (<span>{item.title}</span>)}
        {(!item.return && item.children) ? (<ArrowRight src={assetResolver('arrow-right.svg')} />) : (null)}
      </Item>
    </NavigationItemLink>
  </NavigationItemContainer>
);

PrimaryNavigationItemMobile.propTypes = {
  children: PropType.arrayOf(navigationItemPropType),
  item: navigationItemPropType,
  primarySiteColor: PropType.string,
  onMenuClick: PropType.func,
  onMenuReturn: PropType.func,
  alternate: PropType.bool,
};

PrimaryNavigationItemMobile.defaultProps = {
  children: [],
  item: null,
  primarySiteColor: null,
  onMenuClick: () => undefined,
  onMenuReturn: () => undefined,
  alternate: false,
};

export default PrimaryNavigationItemMobile;
